export const categories = [
  { slug: 'movie', name: '电影', icon: 'ri-film-line', description: '最新院线大片、经典电影、高分佳片' },
  { slug: 'tv', name: '电视剧', icon: 'ri-tv-line', description: '热门国产剧、韩剧、美剧、日剧' },
  { slug: 'anime', name: '动漫', icon: 'ri-emotion-line', description: '日本动漫、国产动漫、剧场版' },
];

export const movies = [
  {
    id: 'movie-1',
    title: '流浪地球3',
    category: 'movie',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20movie%20poster%20with%20astronaut%20and%20spaceship%20in%20deep%20space%2C%20epic%20cinematic%20style%2C%20dramatic%20lighting%2C%20clean%20background%2C%20movie%20poster%20design&width=800&height=1200&seq=pipi-movie-01&orientation=portrait',
    description: '太阳即将毁灭，面对绝境，人类将开启"流浪地球"计划，试图带着地球一起逃离太阳系，寻找人类新家园。第三部延续前作宏大的科幻世界观，将故事推向更高潮。地球在宇宙中流浪的旅程进入最关键阶段，人类面临着前所未有的挑战。',
    rating: 9.2,
    year: 2026,
    director: '郭帆',
    actors: ['吴京', '刘德华', '李雪健', '沙溢', '宁理'],
    region: '中国大陆',
    updateInfo: 'HD高清',
    tags: ['科幻', '冒险', '灾难'],
    featured: true,
    hot: true,
  },
  {
    id: 'movie-2',
    title: '哪吒之魔童闹海',
    category: 'movie',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20fantasy%20movie%20poster%20featuring%20mythological%20character%20with%20fire%20and%20dragon%2C%20vibrant%20colors%2C%20epic%20battle%20scene%2C%20cinematic%20lighting&width=800&height=1200&seq=pipi-movie-02&orientation=portrait',
    description: '天劫之后，哪吒与敖丙的灵魂虽然保住了，但肉身却面临消亡。太乙真人计划用七色宝莲为二人重塑肉身，然而在重塑过程中遇到重重困难。哪吒和敖丙的命运将走向何方？一场关于命运与选择的大战即将拉开帷幕。',
    rating: 9.5,
    year: 2025,
    director: '饺子',
    actors: ['吕艳婷', '陈浩', '囧森瑟夫'],
    region: '中国大陆',
    updateInfo: 'HD高清',
    tags: ['动画', '奇幻', '冒险'],
    featured: true,
    hot: true,
  },
  {
    id: 'movie-3',
    title: '封神第二部：战火西岐',
    category: 'movie',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20mythological%20epic%20movie%20poster%20with%20ancient%20warriors%20in%20battle%2C%20dramatic%20sky%2C%20Chinese%20fantasy%20style%2C%20cinematic%20composition&width=800&height=1200&seq=pipi-movie-03&orientation=portrait',
    description: '殷商大军兵临城下，西岐保卫战一触即发。姜子牙率领众仙与凡人将士共同抵抗纣王的暴政。邓婵玉、闻仲等众多封神名将悉数登场，一场关乎天下苍生的大战在西岐展开，封神大战正式拉开序幕。',
    rating: 8.9,
    year: 2025,
    director: '乌尔善',
    actors: ['费翔', '黄渤', '于适', '陈牧驰'],
    region: '中国大陆',
    updateInfo: '4K超清',
    tags: ['奇幻', '动作', '神话'],
    featured: true,
    hot: false,
  },
  {
    id: 'movie-4',
    title: '奥本海默',
    category: 'movie',
    image: 'https://readdy.ai/api/search-image?query=Oppenheimer%20movie%20poster%20style%20with%20atomic%20explosion%20silhouette%2C%20dramatic%20black%20and%20orange%20tones%2C%20cinematic%20portrait%2C%20intense%20atmosphere&width=800&height=1200&seq=pipi-movie-04&orientation=portrait',
    description: '罗伯特·奥本海默带领一群科学家在新墨西哥州的洛斯阿拉莫斯秘密开发和测试原子弹。随着三位一体核试验的成功，世界从此改变。奥本海默在承担历史重任的同时，也开始反思自己创造的毁灭性武器对人类的深远影响。',
    rating: 8.8,
    year: 2024,
    director: '克里斯托弗·诺兰',
    actors: ['基里安·墨菲', '艾米莉·布朗特', '马特·达蒙'],
    region: '美国',
    updateInfo: 'HD高清',
    tags: ['传记', '历史', '剧情'],
    featured: false,
    hot: true,
  },
  {
    id: 'tv-1',
    title: '庆余年 第二季',
    category: 'tv',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20TV%20series%20poster%20with%20ancient%20Chinese%20palace%20and%20swordsman%2C%20elegant%20costume%20design%2C%20dramatic%20lighting%2C%20cinematic%20style&width=800&height=1200&seq=pipi-tv-01&orientation=portrait',
    description: '范闲从北齐归来后，发现自己已经被卷入了一场更大的阴谋之中。庆帝对他的态度变得越发难以捉摸，而二皇子、太子之间的斗争也愈演愈烈。范闲必须在各方势力之间周旋，同时保护自己珍视的人。',
    rating: 9.3,
    year: 2025,
    director: '孙皓',
    actors: ['张若昀', '李沁', '陈道明', '吴刚'],
    region: '中国大陆',
    updateInfo: '更新至36集',
    tags: ['古装', '权谋', '剧情'],
    featured: true,
    hot: true,
  },
  {
    id: 'tv-2',
    title: '狂飙',
    category: 'tv',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20crime%20drama%20TV%20series%20poster%20with%20police%20and%20underworld%20theme%2C%20dark%20atmosphere%2C%20tense%20mood%2C%20cinematic%20style&width=800&height=1200&seq=pipi-tv-02&orientation=portrait',
    description: '一部横跨二十年的扫黑除恶题材剧集。以一线刑警安欣为代表的正义力量，与以高启强为首的黑恶势力展开了长达二十年的生死较量。通过群像叙事展现扫黑行动中的复杂人性与时代变迁。',
    rating: 9.4,
    year: 2024,
    director: '徐纪周',
    actors: ['张译', '张颂文', '李一桐', '张志坚'],
    region: '中国大陆',
    updateInfo: '全39集',
    tags: ['犯罪', '剧情', '悬疑'],
    featured: false,
    hot: true,
  },
  {
    id: 'tv-3',
    title: '繁花',
    category: 'tv',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20period%20drama%20TV%20series%20poster%20set%20in%201990s%20Shanghai%2C%20nostalgic%20atmosphere%2C%20neon%20lights%2C%20elegant%20costume%2C%20cinematic%20composition&width=800&height=1200&seq=pipi-tv-03&orientation=portrait',
    description: '九十年代的上海，人人都想抓住机遇改变命运。阿宝在商海沉浮中从一个普通青年成长为宝总，经历了成功与失败，在沪上弄潮中见证了一个时代的变迁。繁华背后，是人性的挣扎与命运的流转。',
    rating: 9.0,
    year: 2024,
    director: '王家卫',
    actors: ['胡歌', '马伊琍', '唐嫣', '辛芷蕾'],
    region: '中国大陆',
    updateInfo: '全30集',
    tags: ['年代', '剧情', '商战'],
    featured: false,
    hot: false,
  },
  {
    id: 'tv-4',
    title: '黑暗荣耀',
    category: 'tv',
    image: 'https://readdy.ai/api/search-image?query=Korean%20revenge%20drama%20TV%20series%20poster%20with%20mysterious%20woman%2C%20dark%20elegant%20style%2C%20flowers%20and%20shadows%2C%20cinematic%20atmosphere&width=800&height=1200&seq=pipi-tv-04&orientation=portrait',
    description: '年少时遭受校园暴力的文东恩，花了近二十年时间精心策划了一场复仇。她成为了施暴者孩子的班主任，开始一步步执行自己的复仇计划。在这场精心设计的复仇中，没有人是无辜的。',
    rating: 9.0,
    year: 2024,
    director: '安吉镐',
    actors: ['宋慧乔', '李到晛', '林智妍', '廉惠兰'],
    region: '韩国',
    updateInfo: '全16集',
    tags: ['复仇', '悬疑', '剧情'],
    featured: false,
    hot: false,
  },
  {
    id: 'anime-1',
    title: '鬼灭之刃 柱训练篇',
    category: 'anime',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20poster%20with%20demon%20slayer%20characters%2C%20swords%20and%20flames%2C%20vibrant%20dynamic%20composition%2C%20Japanese%20anime%20art%20style&width=800&height=1200&seq=pipi-anime-01&orientation=portrait',
    description: '为了迎接与鬼舞辻无惨的最终决战，鬼杀队九柱对炭治郎等人展开了严酷的训练。每一位柱都将自己的绝技倾囊相授，炭治郎等人在训练中不断突破自我极限，为最终的决战做好万全准备。',
    rating: 9.1,
    year: 2025,
    director: '外崎春雄',
    actors: ['花江夏树', '鬼头明里', '下野纮'],
    region: '日本',
    updateInfo: '更新至8集',
    tags: ['热血', '战斗', '奇幻'],
    featured: true,
    hot: true,
  },
  {
    id: 'anime-2',
    title: '进击的巨人 最终季',
    category: 'anime',
    image: 'https://readdy.ai/api/search-image?query=Attack%20on%20Titan%20anime%20poster%20with%20giant%20titan%20and%20soldiers%2C%20epic%20dark%20atmosphere%2C%20dramatic%20composition%2C%20Japanese%20anime%20style&width=800&height=1200&seq=pipi-anime-02&orientation=portrait',
    description: '帕拉迪岛的真相被揭开后，艾伦·耶格尔做出了惊人的选择。他发动"地鸣"，率领数千超大型巨人踏平世界。曾经的战友三笠、阿尔敏等人不得不做出艰难决定——阻止艾伦，即使这意味着与他为敌。',
    rating: 9.5,
    year: 2024,
    director: '林祐一郎',
    actors: ['梶裕贵', '石川由依', '井上麻里奈'],
    region: '日本',
    updateInfo: '全12集',
    tags: ['热血', '战斗', '奇幻'],
    featured: false,
    hot: true,
  },
  {
    id: 'anime-3',
    title: '葬送的芙莉莲',
    category: 'anime',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20fantasy%20anime%20poster%20with%20elf%20mage%20in%20beautiful%20landscape%2C%20peaceful%20atmosphere%2C%20soft%20colors%2C%20adventure%20theme&width=800&height=1200&seq=pipi-anime-03&orientation=portrait',
    description: '打倒魔王的勇者一行人中的魔法使芙莉莲，是一个长寿的精灵。在伙伴们相继离世后，她开始了一段"了解人类"的旅程。在这段旅途中，她遇到了新的伙伴，也逐渐理解了那些她曾经与勇者一行人共同度过的时光的意义。',
    rating: 9.4,
    year: 2024,
    director: '斋藤圭一郎',
    actors: ['种崎敦美', '市之濑加那', '小林千晃'],
    region: '日本',
    updateInfo: '全28集',
    tags: ['奇幻', '冒险', '治愈'],
    featured: true,
    hot: false,
  },
  {
    id: 'anime-4',
    title: '咒术回战 第二季',
    category: 'anime',
    image: 'https://readdy.ai/api/search-image?query=Jujutsu%20Kaisen%20anime%20poster%20with%20sorcerers%20fighting%20curses%2C%20dynamic%20action%20scene%2C%20dark%20vibrant%20colors%2C%20Japanese%20anime%20style&width=800&height=1200&seq=pipi-anime-04&orientation=portrait',
    description: '虎杖悠仁吞下宿傩的手指后，成为了宿傩的容器。在五条悟的指导下，他进入东京都立咒术高等专门学校学习咒术。然而，特级咒物"狱门疆"的出现让一切开始走向不可预测的方向，涩谷事变即将爆发。',
    rating: 9.2,
    year: 2024,
    director: '朴性厚',
    actors: ['榎木淳弥', '内田雄马', '濑户麻沙美'],
    region: '日本',
    updateInfo: '全23集',
    tags: ['热血', '战斗', '奇幻'],
    featured: false,
    hot: true,
  },
];

export const featuredMovies = movies.filter((m) => m.featured);
export const hotMovies = movies.filter((m) => m.hot);
export const newMovies = [...movies].sort((a, b) => b.year - a.year).slice(0, 8);